import * as React from "react";
import C from "classnames";
export const InputGroupPrepend = ({ children, className, testId }) => {
    return (React.createElement("div", { className: C("input-group-prepend", className && className), "data-testid": testId }, children));
};
//# sourceMappingURL=InputGroupPrepend.js.map